import React, {Component} from 'react';
import {Alert, Button, message, Modal} from 'antd';
import UserRepo from '../../../repository/user';

class RevokeKey extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    }
  }

  confirm = () => {
    const { user } = this.props;
    Modal.confirm({
      icon: null,
      title: 'Revoke user key',
      content: <>
        Are you sure you want to <b>revoke</b> the key of <b>{user.name}</b>? <br/>
        <br /><br />
        <Alert
          message="Warning"
          description="This process cannot be undone and the user will lose the abilitty to make transactions on ANY he or she may have access to."
          type="warning"
        />
      </>,
      okText: 'Revoke',
      okType: 'danger',
      onOk() {
        UserRepo.revokeKey(user.email).then(
          result => {
            message.success("Key revoked for: " + user.name)
          },
          error => {
            console.log(error.response);
            message.error('Error revoking key');
          }
        )
      },
      onCancel() {
      },
    });
  };

  render() {
    return (
      <>
        <Button type="link" onClick={this.confirm}>Revoke key</Button>
      </>
    );
  }
}

export default RevokeKey;